import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export function Header() {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50" role="banner">
      <nav className="container mx-auto px-4">
        <ul className="flex items-center gap-8 h-16 overflow-x-auto whitespace-nowrap md:whitespace-normal" role="navigation" aria-label="Navigation principale">
          <li>
            <Link
              to="/"
              className={`font-medium transition-colors ${
                isActive('/') ? 'text-orange-500' : 'text-gray-600 hover:text-orange-500'
              }`}
              aria-current={isActive('/') ? 'page' : undefined}
              aria-label="Accueil"
            >
              Accueil
            </Link>
          </li>
          <li>
            <Link
              to="/blog"
              className={`font-medium transition-colors ${
                isActive('/blog') ? 'text-orange-500' : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              Blog
            </Link>
          </li>
          <li>
            <Link
              to="/tools"
              className={`font-medium transition-colors ${
                isActive('/tools') ? 'text-orange-500' : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              Outils IA
            </Link>
          </li>
          <li>
            <Link
              to="/ai-booster-sprint"
              className={`font-medium transition-colors ${
                isActive('/ai-booster-sprint') ? 'text-orange-500' : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              AI Booster Sprint
            </Link>
          </li>
          <li>
            <Link
              to="/quiz"
              className={`font-medium transition-colors ${
                isActive('/quiz') ? 'text-orange-500' : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              Quiz IA
            </Link>
          </li>
          <li>
            <Link
              to="/bootcamp"
              className={`font-medium transition-colors ${
                isActive('/bootcamp') ? 'text-orange-500' : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              Bootcamp IA
            </Link>
          </li>
          <li>
            <Link
              to="/calculateur-roi"
              className={`font-medium transition-colors ${
                isActive('/calculateur-roi') ? 'text-orange-500' : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              Calculateur ROI
            </Link>
          </li>
          <li>
            <Link
              to="/recommandation"
              className={`font-medium transition-colors flex items-center gap-1 ${
                isActive('/recommandation') ? 'text-orange-500' : 'text-gray-600 hover:text-orange-500'
              }`}
            >
              Recommandez Novster
              <span className="px-2 py-0.5 bg-orange-100 text-orange-600 text-xs rounded-full">10%</span>
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}